<template>
    <div v-if="scope.row[config.prop]">
        {{ scope.row[config.prop] }}
    </div>
    <div v-else>
      无对应字段~
    </div>
</template>

<script>

export default {
    name: "TUpdateTime",
    cName:'更新时间',
    defaultProp:'update_time',
    // functional: true,
    // Props 是可选的
    props: ["scope", "config"],
    data() {
        return {
        };
    }
};
</script>
